import { Box, Typography, useTheme } from '@mui/material';
import { PurchaseHistoryStatusType } from '@types';
import { FontAwesomeIcon as I } from '@fortawesome/react-fontawesome';
import { purchaseStatus, rem } from '@utils';

interface StatusTagProps {
    status: PurchaseHistoryStatusType;
}

const StatusTag = ({ status }: StatusTagProps) => {
    const { typography, palette } = useTheme();

    return (
        <Typography
            component='div'
            sx={{
                fontSize: rem(12),
                fontWeight: typography.fontWeightSemiBold,
                color: palette.mediumGray,
                display: 'flex',
            }}>
            <Box mr={typography.pxToRem(4)}>
                <I icon={['fas', 'circle']}
                    color={purchaseStatus(status)[status].color}
                    fontSize={10} />
            </Box>
            {purchaseStatus(status)[status]?.title ?? ''}
        </Typography>
    );
};

export { StatusTag };
